import React from 'react'

import BInput from 'components/Form/Fields/BInput'
import FormHandler from 'components/Form/FormHandler'

export const DeliveryAddressFields = ({t, root}) => (
  <>
    <BInput fieldName='streetAddress1' fieldNameRoot={root} label={t('streetAddress1')} required/>
    <BInput fieldName='streetAddress2' fieldNameRoot={root} label={t('streetAddress2')}/>
    <BInput fieldName='city' fieldNameRoot={root} label={t('City')} required/>
    <BInput fieldName='region' fieldNameRoot={root} label={t('Region')}/>
    <BInput fieldName='zip' fieldNameRoot={root} label={t('ZIP')} required/>
    <BInput fieldName='additionalInfo' fieldNameRoot={root} label={t('Additional info')}/>
  </>
)


const DeliveryAddress = ({t, data, submitCallback, deleteCallback, submitTitle}) => (
  <FormHandler
    initialValues={data}
    submitCallback={submitCallback}
    submitTitle={submitTitle}
    additionalButtons={deleteCallback ? (
      <button
        className='deliveryAddress-remove'
        onClick={e => {
          e.preventDefault()
          deleteCallback(data.uuid)
        }}
        style={{marginLeft: '1em'}}
      >
        {t('Remove this address')}
      </button>
    ) : undefined}
  >
    <BInput fieldName='uuid' hidden/>
    <BInput fieldName='contactName' label={t('contactName')} required/>
    <DeliveryAddressFields t={t}/>
  </FormHandler>
)

export default DeliveryAddress
